import React from 'react';

const date = new Date().getFullYear();

function Main({childElem}) {
  return (
    <main class="main">{childElem}</main>
  );
}

function Section({childElem}) {
  return (
    <section class="page-section">{childElem}</section>
  );
}

// function Container({childElem}) {
//   return (
//     <div class="container">{childElem}</div>
//   );
// }

function Logo() {
  return (
    <img class="logo" alt="Father & Seed logo" src="fas-logo01.png" />
  );
}

function HomeNav() {
  return (
    <div class="nav-container">
      <a class="nav-item" href="#catalog">Seed Catalog</a>
      <a class="nav-item" href="#about">About</a>
      <a class="nav-item" href="#contact">Contact</a>  
    </div>
  );
}

function HomePrimary() {
  return (
    <div class="home-primary"><Logo /><HomeNav /></div>
  );
}

function AboutSection() {
  return (
    <div class="section-content" id="about">
      <h2>About Father & Seed Co.</h2>
      <p>It wasn’t just one seed that sprouted the Father And Seed company, but a collection of them. It was born out of a desire to share and instill an entrepreneurial spirit within my son, Isaiah. To show him that you can create something with just the earth beneath you, the rain from the sky and the sun’s rays that shine down. It also was the curiosity to see what might happen if I left the carrots, collards and kale to overwinter in the raised beds and allowed to bolt in the Spring. It was the simple and spacious organizer gifted to me by my mother-in-law so that I can neatly store the seeds I planned to use for the next season. It was the sage advice given to me by family members as I built a raised-bed vegetable and flower garden while many of us were sequestered at home in 2020. As I started to read, connect and learn about the art of seed saving I realized it is so much more. It is about tapping into a practice as old as civilization itself while at the same time connecting with future generations, ensuring they too can enjoy the smell, taste and beauty of these plants.</p>
      <h3>Our Seed Guarantee</h3>: <p>If you are not satisfied with your seed packet let us know and we will exchange or refund your purchase. Nature is unpredictable and we’re but a seedling of a company still learning as we go. We’d also love to hear about your successes too. You can reach us at fatherandseed@proton.me</p>
      <p>Enjoy the journey,<br />Dan & Isaiah Sherman</p>
    </div>
  );
}

function ContactSection() {
    return (
    <div class="section-content" id="contact">
      <h2>Contact Us</h2>
      <img src="img/IMG_7408.png" alt="Father and Seed Co. founders Dan and Isaiah Sherman" width="200" />
      <p>Email: fatherandseed@proton.me</p>
    </div>
  );
}

function CatalogSection() {
    return (
      <div class="section-content" id="catalog">
        <h2>Seed Catalog</h2>
          <p>Flowers</p>
            <div class="flex-container">
              <span class="item">
                <img src="img/IMG_5375.png" alt="Northeast Wildflower Mix Seed Packet" width="100" />
                <p>Northeast Wildflower Mix</p>
              </span>
              <span class="item">
                <img src="img/IMG_5385.png" alt="Northeast Wildflower Mix Seed Packet" width="100" />
                <p>Calendula</p>
              </span>
                <span class="item">
                <img src="img/IMG_5384.png" alt="Northeast Wildflower Mix Seed Packet" width="100" />
                <p>Iris</p>
              </span>
              <span class="item">
                <img src="img/IMG_5383.png" alt="Northeast Wildflower Mix Seed Packet" width="100" />
                <p>Daylilly</p>
              </span>
              <span class="item">
                <img src="img/IMG_5382.png" alt="Northeast Wildflower Mix Seed Packet" width="100" />
                <p>Coneflowers</p>
              </span>
              <span class="item">
                <img src="img/IMG_5381.png" alt="Northeast Wildflower Mix Seed Packet" width="100" />
                <p>Marigolds</p>
              </span>
              <span class="item">
                <img src="img/IMG_5380.png" alt="Northeast Wildflower Mix Seed Packet" width="100" />
                <p>Black Eyed Susans</p>
              </span>
            </div> 
          <p>Herbs</p>
            <div class="flex-container">
              <span class="item">
                <img src="img/IMG_5375.png" alt="Northeast Wildflower Mix Seed Packet" width="100" />
                <p>Basil</p>
              </span>
              <span class="item">
                <img src="img/IMG_5376.png" alt="Northeast Wildflower Mix Seed Packet" width="100" />
                <p>Cilantro</p>
              </span>
              <span class="item">
                <img src="img/IMG_5379.png" alt="Northeast Wildflower Mix Seed Packet" width="100" />
                <p>Dill</p>
              </span>
            </div>
          <p>Vegatables</p>
            <div class="flex-container">
              <span class="item">
                <img src="img/IMG_5377.png" alt="Northeast Wildflower Mix Seed Packet" width="100" />
                <p>Carrots</p>
              </span>
              <span class="item">
                <img src="img/IMG_5378.png" alt="Northeast Wildflower Mix Seed Packet" width="100" />
                <p>Kale</p>
              </span>
            </div>
      </div>
    );
}

function Footer() {
  return (
    <div class="footer">
      <p>©{date} Father & Seed Co. All rights reserved.</p>
      <p>🐢 turtle</p>
    </div>
  );
}

function HomeLayout() {
  return (
    <div>
      <Section childElem={<HomePrimary />} />
      <Section childElem={<CatalogSection />} />
      <Section childElem={<AboutSection />} />
      <Section childElem={<ContactSection />} />
      <Footer />
    </div>
  )
}

function App() {
  // return <div><LogoContainer /><Footer /></div>;
  return <Main childElem={<HomeLayout />} />;
}

export default App;
